import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Typography } from '@mui/material';
import WebRoundedIcon from '@mui/icons-material/WebRounded';
import capitalize from '../../../../Helpers/StringsFormatting/capitalize';

const DesktopComponents = function DesktopComponents({ title = '' }) {
  const intl = useIntl();

  return (
    <div
      style={{
        display: 'flex',
        gap: '16px',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        height: '10%',
      }}
    >
      <div style={{ display: 'flex', gap: 12, width: '33%' }}>
        <div
          style={{
            borderRadius: 50,
            backgroundColor: '#ec6a5a',
            width: '20px',
            height: '20px',
          }}
        />
        <div
          style={{
            borderRadius: 50,
            backgroundColor: '#fcc15d',
            width: '20px',
            height: '20px',
          }}
        />
        <div
          style={{
            borderRadius: 50,
            backgroundColor: '#67c45c',
            width: '20px',
            height: '20px',
          }}
        />
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 12,
          flexGrow: 1,
        }}
      >
        <WebRoundedIcon sx={{ opacity: 0.54, fontSize: '2.5rem' }} />
        <Typography variant="h4" sx={{ opacity: 0.54 }}>
          {capitalize(title) || intl.messages.UNAVAILABLE}
        </Typography>
      </div>
      <div style={{ width: '33%' }} />
    </div>
  );
};

DesktopComponents.propTypes = {
  title: PropTypes.string,
};
export default DesktopComponents;
